module.exports = __webpack_public_path__ + "img/report-11.200c2ebf.jpg";